export var ManualProcessStatusType;
(function (ManualProcessStatusType) {
    ManualProcessStatusType["PENDING"] = "pending";
    ManualProcessStatusType["PROCESSING"] = "processing";
    ManualProcessStatusType["FAILED"] = "failed";
})(ManualProcessStatusType || (ManualProcessStatusType = {}));
//# sourceMappingURL=ManualProcessStatusType.js.map